<div class="main-container">
  <mat-toolbar
    color="primary"
    class="topbar telative"
    fxLayoutAlign="space-between center"
  >
    <div class="navbar-header">
      <a class="navbar-brand" routerLink="/">
        <img
          src="https://wikipapa.org/images/wikipapa-logo.png"
          alt="homepage"
          class="light-logo"
          height="42px"
        />
      </a>
    </div>

    <app-header></app-header>
  </mat-toolbar>

  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
  >
    <mat-sidenav-content class="page-wrapper">
      <div class="page-container">
        <div class="page-content">
          <router-outlet>
            <!-- <app-spinner></app-spinner>  -->
          </router-outlet>
        </div>
      </div>

      <button
        mat-fab
        color="primary"
        (click)="scrollRestoration()"
        title="Ir arriba"
        style="
          position: fixed;
          right: 30px;
          bottom: 15px;
          background-color: #e7154aad;
          z-index: 10;
        "
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>

      <footer class="footer-07">
        <div class="container">
          <div class="justify-content-center">
            <div class="col-md-12 text-center">
              <h2 class="footer-heading">
                <a href="#" class="logo">WikiPapa </a>
              </h2>
              <div style="margin-top: -32px">
                <small style="color: #fff">version 3.1.5</small>
              </div>
              <p class="menu">
                <button
                  mat-button
                  color="primary"
                  (click)="navigateToView('inicio')"
                >
                  Inicio
                </button>

                <button
                  mat-button
                  color="primary"
                  (click)="navigateToView('nosotros')"
                >
                  Accerca de
                </button>

                <button
                  mat-button
                  color="primary"
                  (click)="navigateToView('observaciones')"
                >
                  Explora
                </button>

                <button
                  *ngIf="isLoggedIn()"
                  mat-button
                  color="primary"
                  (click)="fnGoToView('observaciones', true)"
                >
                  Mis Observaciones
                </button>

                <button
                  mat-button
                  color="primary"
                  (click)="navigateToView('catalogo')"
                >
                  Catálogo
                </button>

                <button
                  mat-button
                  color="primary"
                  (click)="navigateToView('contacto')"
                >
                  Contacto
                </button>
              </p>
            </div>

            <div style="display: flex; justify-content: center">
              <div
                class="mat-elevation-z6"
                style="width: 150px; height: 45.04px"
                matRipple
                (click)="
                  goToView(
                    'https://play.google.com/store/apps/details?id=org.varscout.app'
                  )
                "
              >
                <img src="assets/images/google-play.png" width="100%" />
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="col-md-12 text-center">
              <p class="copyright">
                Copyright ©
                <script>
                  document.write(new Date().getFullYear());
                </script>
                2025 All rights reserved | This website is developed
                <i class="ion-ios-heart" aria-hidden="true"></i> by
                <a href="https://metrikagr.com/" target="_blank" 
                 rel="noopener noreferrer" >Metrika Group</a
                >
              </p>
            </div>
          </div>
        </div>
      </footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
